import { cx } from '@libs/classnames';
import { MiniShieldIcon } from '@ui/icons/MiniShieldIcon/MiniShieldIcon';

import { PlayerShieldPopoverWidget } from '@features/user/ui/PlayerShieldPopover/PlayerShieldPopoverWidget';
import { usePlayerShieldPopover } from '@features/user/ui/PlayerShieldPopover/usePlayerShieldPopover';

import styles from './PlayerShieldQuickPeek.module.css';

type Props = {
  userId?: string | null;
  className?: string;
};
export function PlayerShieldQuickPeekWidget({ userId, className }: Props) {
  const playerShieldPopover = usePlayerShieldPopover();

  if (!userId) return null;

  return (
    <div className={cx(styles.quickPeek, className)}>
      <div
        ref={playerShieldPopover.anchorRef}
        className={styles.button}
        onClick={playerShieldPopover.open}
        onMouseEnter={playerShieldPopover.miniShieldMouseEnter}
        onMouseLeave={playerShieldPopover.miniShieldMouseLeave}
      >
        <MiniShieldIcon />
      </div>

      <PlayerShieldPopoverWidget userId={userId} {...playerShieldPopover.props} />
    </div>
  );
}
